import type { TefComs4p } from '@mfe/components/TefComs4p';
import { textToUnsafeHTML } from '@mfec/lit/textToUnsafeHTML';
import { Purpose } from '@mfec/types/model';
import { html } from 'lit';

//
// renders a <a> with a connected modal
//
export const tefPurposeDescriptionModal = function render(this: TefComs4p, purpose: Purpose) {
  return html`
      <tef-modal-trigger modal-id="purpose-desc-${purpose.purposeId}">
        <a href="#purpose-desc-${purpose.purposeId}" style="white-space: nowrap">Weitere Informationen</a>
      </tef-modal-trigger>
      <tef-modal id="purpose-desc-${purpose.purposeId}" close-icon color-close-icon>
        <div slot="title">${purpose.title}</div>
        <div slot="body">
          ${textToUnsafeHTML(purpose.description)}
        </div>
      </tef-modal>
    `;
};
